// extracted by mini-css-extract-plugin
module.exports = {"centerDiv":"featured-selected_centerDiv__3HDGN","logoCause":"featured-selected_logoCause__1GVeY"};